<template>
  <div class="legal-page">
    <div class="legal-page__band text-center">
      <b-img
        :src="business.logo"
        :alt="business.name"
        height="40"
        class="mb-1"
      />
      <div class="legal-page__brand">
        {{ business.name }}
      </div>
      <h1 class="legal-page__title mb-0">
        {{ title }}
      </h1>
      <p
        v-if="intro"
        class="legal-page__intro mx-auto mb-0"
      >
        {{ intro }}
      </p>
    </div>

    <b-container class="legal-page__container">
      <div class="legal-content">
        <slot />
      </div>

      <hr class="legal-page__divider">

      <div class="text-center legal-links mb-2">
        <template v-for="link in legalLinks">
          <span
            v-if="link.name === $route.name"
            :key="link.name"
            class="text-muted"
          >{{ link.label }}</span>
          <b-link
            v-else
            :key="link.name"
            :to="{ name: link.name }"
          >
            {{ link.label }}
          </b-link>
        </template>
      </div>
      <div class="text-center text-muted small">
        <div>
          {{ business.name }} · {{ business.address }} ·
          {{ business.country }}
        </div>
        <div>
          Tel:
          <a :href="`tel:${business.phone}`">{{ business.phone }}</a>
          ·
          <a :href="`mailto:${business.email}`">{{
            business.email
          }}</a>
        </div>
        <b-link
          class="d-inline-block mt-1"
          :to="{ name: 'home' }"
        >
          ← Volver al inicio
        </b-link>
      </div>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BLink, BImg } from "bootstrap-vue"
import business from "@/business"

export default {
  components: { BContainer, BLink, BImg },
  props: {
    title: { type: String, required: true },
    intro: { type: String, default: "" },
  },
  data() {
    return {
      business,
      legalLinks: [
        { name: "legal-services", label: "Servicios" },
        { name: "legal-terms", label: "Términos" },
        { name: "legal-privacy", label: "Privacidad" },
        { name: "legal-security", label: "Seguridad" },
        { name: "legal-refunds", label: "Devoluciones" },
        { name: "legal-delivery", label: "Entrega" },
        { name: "legal-contact", label: "Contacto" },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.legal-page__band {
    background-color: var(--tm-surface-muted);
    padding: 3rem 1.5rem 2.5rem;
}

.legal-page__brand {
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--tm-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 0.5rem;
}

.legal-page__title {
    font-size: 2.125rem;
    font-weight: 700;
    color: var(--tm-text);
    letter-spacing: -0.01em;
}

.legal-page__intro {
    max-width: 560px;
    margin-top: 0.875rem;
    font-size: 0.9375rem;
    color: var(--tm-text-secondary);
    line-height: 1.7;
}

.legal-page__container {
    max-width: 800px;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
}

.legal-page__divider {
    border-color: var(--tm-border);
    margin: 0.5rem 0 1.75rem;
}

@media (max-width: 576px) {
    .legal-page__band {
        padding: 2.25rem 1.25rem 2rem;
    }

    .legal-page__title {
        font-size: 1.625rem;
    }
}

.legal-content >>> h4 {
    font-size: 1rem;
    font-weight: 600;
    margin: 1.75rem 0 0.5rem;
    color: var(--tm-text);
}

.legal-content >>> p {
    color: var(--tm-text-secondary);
    line-height: 1.7;
    margin-bottom: 0.875rem;
}

/* Contenedor de las tarjetas de sección: lo usan todas las páginas de
   políticas, así que vive acá y no repetido en cada una. */
.legal-content >>> .legal-sections {
    display: grid;
    gap: 1rem;
}

/* Dentro de una tarjeta el último párrafo no lleva el margen de separación:
   duplicaba el padding inferior de la tarjeta. */
.legal-content >>> .legal-section p:last-child,
.legal-content >>> .legal-section ul:last-child {
    margin-bottom: 0;
}

.legal-content >>> ul {
    color: var(--tm-text-secondary);
    line-height: 1.8;
}

.legal-content >>> a {
    text-decoration: underline;
}

.legal-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.25rem 0.75rem;
    font-size: 0.8125rem;
}
</style>
